import { createRouter, createWebHashHistory, createWebHistory } from 'vue-router'
import HomeView from '../views/Home.vue'
// import KpiForm from '../views/KpiForm.vue'
import store from '../store/index.js'

const routes = [
  {
    path: '/',
    name: 'home',
    component: HomeView
  },
  {
    path: '/about',
    name: 'about',
    component: () => import('@/views/AboutView.vue')
  },
  {
    path: '/about/privacy',
    name: 'privacy',
    component: () => import('@/views/AboutPrivacy.vue')
  },
  {
    path: '/about/terms',
    name: 'terms',
    component: () => import('@/views/AboutTerms.vue')
  },
  {
    path: '/about/eula',
    name: 'eula',
    component: () => import('@/views/AboutEula.vue')
  },
  {
    path: '/about/disclaimer',
    name: 'disclaimer',
    component: () => import('@/views/AboutDisclaimer.vue')
  },
  {
    path: '/about/cookies',
    name: 'cookies',
    component: () => import('@/views/AboutCookies.vue')
  },
  {
    path: '/about/use',
    name: 'use',
    component: () => import('@/views/AboutUse.vue')
  },
  {
    path: '/about/dsar',
    name: 'dsar',
    component: () => import('@/views/AboutDsarForm.vue')
  },
  {
    path: '/about/vision',
    name: 'vision',
    component: () => import('@/views/company/VisionView.vue')
  },
  {
    path: '/about/team',
    name: 'team',
    component: () => import('@/views/company/TeamView.vue')
  },
  {
    path: '/auth/login',
    name: 'login',
    component: () => import('@/components/LoginView.vue')
  },
  {
    path: '/auth/passwordforgotten',
    name: 'passwordforgotten',
    component: () => import('@/components/PasswordForgotten.vue')
  },
  {
    path: '/auth/register',
    name: 'register',
    component: () => import('@/views/RegisterUser.vue')
  },
  {
    path: '/auth/userprofile',
    name: 'userprofile',
    component: () => import('@/components/forms/UserProfile.vue')
  },
  {
    path: '/application',
    name: 'application',
    component: () => import('@/views/ApplicationView.vue')
  },
  {
    path: '/event/:id',
    name: 'eventSingle',
    component: () => import('@/views/EventSingle.vue'),
  },
  {
    path: '/kpis',
    name: 'kpilist',
    component: () => import('@/views/KpiList.vue'),
  },
  {
    path: '/kpis/create',
    name: 'kpiform',
    // lazy importing of this view led to an error when calling kpiedit in first place
    // component: KpiForm,
    component: () => import('@/views/KpiForm.vue'),
  },
  {
    path: '/kpis/edit/:id',
    name: 'kpiedit',
    component: () => import('@/views/KpiForm.vue'),
  },
  {
    path: '/templates',
    name: 'templates',
    component: () => import("@/views/AssessmentTemplateList.vue"),
  },
  {
    path: '/templates/:id',
    name: 'assessmenttemplate',
    component: () => import("@/views/AssessmentTemplateDetail.vue")
  },
  {
    path: '/templates/edit/:id',
    name: 'assessmenttemplateform',
    component: () => import("@/views/AssessmentTemplateForm.vue")
  },
  {
    path: '/projects',
    name: 'projectlist',
    component: () => import("@/views/ProjectList.vue")
  },
  {
    path: '/projects/:id',
    name: 'projectdetail',
    component: () => import("@/views/ProjectDetail.vue")
  },
  {
    path: '/projects/:id/dashboard',
    name: 'projectdashboard',
    component: () => import("@/views/ProjectDashboard.vue")
  },
  {
    path: '/projects/:id/documents',
    name: 'projectdocuments',
    component: () => import("@/views/DocumentView.vue")
  },
  {
    path: '/projects/:id/dashboard/:kpi/edit',
    name: 'projectdashboardkpiedit',
    component: () => import("@/views/ProjectKpiEditCard.vue")
  },
  {
    path: '/projects/:id/buddy',
    name: 'buddy',
    component: () => import("@/views/Buddy.vue")
  },
  {
    path: '/projects/:id/ai',
    name: 'ai',
    component: () => import("@/views/AiView.vue")
  },
  {
    path: '/planning',
    name: 'planning',
    component: () => import("@/views/PlanningOverview.vue")
  },
  {
    path: '/tasks',
    name: 'tasks',
    component: () => import("@/views/TaskTimeLine2.vue")
  },
  {
    path: '/timeline',
    name: 'timeline',
    component: () => import("@/views/TaskTimeLine.vue")
  },
  {
    path: '/suggestions/addkpi/:projectId',
    name: 'suggestionsaddkpi',
    component: () => import("@/views/SuggestionsAddKpi.vue")
  },
  {
    path: '/suggestions/improve',
    name: 'suggestionsimprove',
    component: () => import("@/views/SuggestionsImproveImpact.vue")
  },
  {
    path: '/suggestions/initiate',
    name: 'suggestionsinitiate',
    component: () => import("@/views/SuggestionsInitiateImpact.vue")
  },
  {
    path: '/suggestions/reduce',
    name: 'suggestionsreduce',
    component: () => import("@/views/SuggestionsReduceCost.vue")
  },
  {
    path: '/projects/:id/context',
    name: 'projectcontext',
    component: () => import("@/views/Context.vue")
  },
  {
    path: '/projectsconsolidatedreport',
    name: 'projectsconsolidatedreport',
    component: () => import("@/views/ProjectConsolidatedReport.vue")
  },
  {
    path: '/projects/:projectid/:projectkpiid/task/new',
    name: 'projecttasknew',
    component: () => import("@/views/Task.vue")
  },
  {
    path: '/projects/:projectid/:projectkpiid/task/:taskid',
    name: 'projecttask',
    component: () => import("@/views/Task.vue")
  },
  {
    path: '/projects/:id/delegate',
    name: 'delegate',
    component: () => import ("@/views/DelegateView.vue")
  },
  {
    path: '/projects/:id/edit',
    name: 'edit',
    component: () => import ("@/views/ProjectEdit.vue")
  },
  {
    path: '/projects/:id/goals',
    name: 'goals',
    component: () => import ("@/views/ProjectGoals.vue")
  },
  {
    path: '/projects/:id/assessment',
    name: 'assessment',
    component: () => import ("@/views/ProjectAssessment.vue")
  },
  {
    path: '/projects/:id/assessment/detail',
    name: 'assessmentdetail',
    component: () => import ("@/views/ProjectAssessmentDetail.vue")
  },
  {
    path: '/newproject/1',
    name: 'newproject1',
    component: () => import ("@/views/NewProject1.vue")
  },
  {
    path: '/newproject',
    name: 'newproject',
    component: () => import ("@/views/NewProject.vue")
  },
  {
    path: '/newsroom',
    name: 'newsroom',
    component: () => import ("@/views/Newsroom.vue")
  },
  {
    path: '/newsroom/trainings',
    name: 'newsroomtrainings',
    component: () => import ("@/views/NewsroomTrainings.vue")
  },
  {
    path: '/newsroom/warnings',
    name: 'newsroomwarnings',
    component: () => import ("@/views/NewsroomWarnings.vue")
  },
  {
    path: '/newsroom/subsidies',
    name: 'newsroomsubsidies',
    component: () => import ("@/views/NewsroomSubsidies.vue")
  },
  {
    path: '/newsroom/organization',
    name: 'newsroomorganization',
    component: () => import ("@/views/NewsroomOrganization.vue")
  },
  {
    path: '/forms/news/:id',
    name: 'formsnewsedit',
    component: () => import ("@/components/forms/NewsForm.vue")
  },
  {
    path: '/forms/news/add',
    name: 'formsnewsadd',
    component: () => import ("@/components/forms/NewsForm.vue")
  },
  {
    path: '/forms/suggestions/:id',
    name: 'formssuggestionedit',
    component: () => import ("@/components/forms/SuggestionForm.vue")
  },
  {
    path: '/forms/suggestions/add',
    name: 'formssuggestionadd',
    component: () => import ("@/components/forms/SuggestionForm.vue")
  },
  {
    path: '/survey',
    name: 'survey',
    component: () => import ("@/views/SurveyList.vue")
  },
  {
    path: '/survey/:id',
    name: 'surveyedit',
    component: () => import ("@/views/SurveyForm.vue")
  },
  {
    path: '/survey/new',
    name: 'surveynew',
    component: () => import ("@/views/SurveyForm.vue")
  },
  {
    path: '/campaign',
    name: 'campaign',
    component: () => import ("@/views/CampaignList.vue")
  },
  {
    path: '/campaign/:id',
    name: 'campaignedit',
    component: () => import ("@/views/CampaignForm.vue")
  },
  {
    path: '/campaign/new',
    name: 'campaignnew',
    component: () => import ("@/views/CampaignForm.vue")
  },
  {
    path: '/campaign/collect',
    name: 'campaigncollectlist',
    component: () => import ("@/views/CampaignCollectorList.vue")
  },
  {
    path: '/campaign/collect/:id',
    name: 'campaigncollect',
    component: () => import ("@/views/CampaignCollector.vue")
  },
  {
    path: '/form/:service',
    name: 'genericform',
    component: () => import ("@/components/forms/GenericForm.vue")
  },
  {
    path: '/form/:service/:id',
    name: 'genericformedit',
    component: () => import ("@/components/forms/GenericForm.vue")
  },
  {
    path: '/list/:service',
    name: 'genericlist',
    component: () => import ("@/components/partials/GenericList.vue")
  },
  {
    path: '/something',
    name: 'somethingsuggestion',
    component: () => import ("@/views/SomethingSuggestion.vue")
  },
]

const router = createRouter({
  // history: createWebHistory(process.env.BASE_URL),
  history: createWebHashHistory(),
  routes
})


router.beforeEach(async (to, from) => {
  console.log(router);
  if (!store.getters["auth/isAuthenticated"]
      && to.name !== 'login'
      && to.name !== 'home'
      && to.name !== 'about'
      && to.name !== 'privacy'
      && to.name !== 'cookies'
      && to.name !== 'terms'
      && to.name !== 'eula'
      && to.name !== 'disclaimer'
      && to.name !== 'use'
      && to.name !== 'dsar'
      && to.name !== 'register'
      && to.name !== 'somethingsuggestion'
      && to.name !== 'passwordforgotten'
      && to.name !== 'team'
      && to.name !== 'vision'
      && to.name !== 'application'
  ) {
    return { name: 'login' }
  }
})




export default router
